import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconCanceledProps {
  color?: string;
  noMargin?: boolean;
  tooltip?: string;
}

export const ListStateIconCanceled = ({
    noMargin,
    tooltip,
    color = "error",
}: ListStateIconCanceledProps) => (
    <ListStateIcon
        color={color}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={DoNotDisturbIcon}
    />
);
